import Component from 'flarum/common/Component';
export default class Turnstile extends Component {
  oncreate(vnode) {
    super.oncreate(vnode);
    const theme = this.detectTheme();
    this.attrs.state.render(vnode.dom.querySelector('.cf-turnstile'), theme);
  }
  onremove(vnode) {
    this.attrs.state.remove();
    super.onremove(vnode);
  }
  detectTheme() {
    const currentTheme = document.documentElement.dataset.theme || 'light';
    return currentTheme.startsWith('dark') ? 'dark' : 'light';
  }
  view() {
    return m("div", {
      className: "Form-group"
    }, m("div", {
      className: "cf-turnstile"
    }));
  }
}
flarum.reg.add('flectar-turnstile', 'forum/components/Turnstile', Turnstile);